import ReferenceApi from '../api/ReferenceApi';

export default {
  async getTemplateCollection(): Promise<any[]> {
    const users: any[] = [];
    const response = await ReferenceApi.getTemplateCollection();

    response.data.data.forEach((userObj: any) => {
      users.push({
        uuid: userObj.id,
        ...userObj.attributes,
      });
    });

    return users;
  },
  async getAllDataCollectionPages(
    tenantUUID: string,
    params: any = {}
  ): Promise<{ data: any[]; templates: any[] }> {
    const data: any[] = [];
    const pageResponses = await ReferenceApi.getAllDataCollectionPages(
      tenantUUID,
      params
    );

    pageResponses.forEach((response: any) => {
      response.data.data.forEach((taskObj: any) => {
        data.push({
          uuid: taskObj.id,
          ...taskObj.attributes,
          templateId: taskObj.relationships.template.data.id,
        });
      });
    });

    const templates: any[] = [];
    pageResponses.forEach((response: any) => {
      if(response.data.included) {
        response.data.included.forEach((templateObj: any) => {
          if (templateObj.type === 'templates') {
            templates.push({
              uuid: templateObj.id,
              ...templateObj.attributes,
            });
          }
        });
      }
    });

    return { data, templates };
  },

  async getSingleDataHistory(
    tenantUUID: string,
    templateUUID: string,
    entityId: string
  ): Promise<
    Array<{
      id: string;
      revisionTime: string | null;
      revisionType: 'create' | 'update' | string | null;
      entityType: string | null;
      payload: Record<string, any>;
    }>
  > {
    const res = await ReferenceApi.getSingleDataHistory(
      tenantUUID,
      templateUUID,
      entityId
    );

    const items = Array.isArray(res?.data?.data) ? res.data.data : [];
    return items.map((entry: any) => ({
      id: entry.id,
      revisionTime: entry?.meta?.revisionTime ?? null,
      revisionType: entry?.meta?.revisionType ?? null,
      entityType: entry?.attributes?.entityType ?? null,
      payload: entry?.attributes?.payload ?? {},
    }));
  },
  async createData(
    tenantUUID: string,
    templateUUID: string,
    entityType: string,
    payload: object
  ): Promise<any> {
    const response = await ReferenceApi.createData(
      tenantUUID,
      templateUUID,
      entityType,
      payload
    );

    if (response.data.data.type && response.data.data.type == 'data') {
      return {
        uuid: response.data.data.id,
        ...response.data.data.attributes,
      };
    } else {
      throw TypeError('Response not type data');
    }
  },
  async addData(
    tenantUUID: string,
    templateUUID: string,
    entityId: string,
    entityType: string,
    payload: object
  ): Promise<any> {
    const response = await ReferenceApi.addData(
      tenantUUID,
      templateUUID,
      entityId,
      entityType,
      payload
    );

    if (response.data.data.type && response.data.data.type == 'data') {
      return {
        uuid: response.data.data.id,
        ...response.data.data.attributes,
      };
    } else {
      throw TypeError('Response not type data');
    }
  },
  async updateData(
    tenantUUID: string,
    templateUUID: string,
    entityId: string,
    payload: object
  ): Promise<any> {
    const response = await ReferenceApi.updateData(
      tenantUUID,
      templateUUID,
      entityId,
      payload
    );

    if (response.data.data.type && response.data.data.type == 'data') {
      return {
        uuid: response.data.data.id,
        ...response.data.data.attributes,
      };
    } else {
      throw TypeError('Response not type data');
    }
  },
  async deleteData(
    tenantUUID: string,
    templateUUID: string,
    entityId: string
  ): Promise<any> {
    await ReferenceApi.deleteData(tenantUUID, templateUUID, entityId);
  },
  async getUserPermissions(userUUID: string): Promise<any> {
    const perms: any[] = [];
    const response = await ReferenceApi.getUserPermissions(userUUID);

    response.data.data.forEach((userObj: any) => {
      perms.push({
        uuid: userObj.id,
        ...userObj.attributes,
        tenant: {
          identifier: userObj.relationships.tenant.data.id.split(':')[1],
          service: 'bascloud',
        },
      });
    });

    return perms;
  },
  async addUserPermission(
    tenantUUID: string,
    userUUID: string,
    entityType: string,
    permission: string,
    filter: object
  ): Promise<any> {
    const response = await ReferenceApi.addUserPermission(
      tenantUUID,
      userUUID,
      entityType,
      permission,
      filter
    );

    if (response.data.data.type && response.data.data.type == 'permissions') {
      return {
        uuid: response.data.data.id,
        ...response.data.data.attributes,
        tenant: {
          identifier: response.data.data.relationships.tenant.data.id,
          service: 'bascloud',
        },
      };
    } else {
      throw TypeError('Response not type permissions');
    }
  },
  async deleteUserPermissions(permissionUUID: string): Promise<any> {
    await ReferenceApi.deleteUserPermissions(permissionUUID);
  },
};
